module.exports = __webpack_public_path__ + "static/img/t-sample01.d0011104.svg";